export default __webpack_public_path__ + "assets/logos/7c77d8c79e6d4ae769cf3322008a7135.png";